// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"ResultDeal_iconSync__2ywhd","fa-spin":"ResultDeal_fa-spin__29sr6","iconInfo":"ResultDeal_iconInfo__Si5Vy"};